import YearQuarter from "entities/yearQuarter";
import { groupBy, toArray } from "lodash";
import { computed, observable } from "mobx";
import type Month from "../entities/month";
import type EdazLivingMonthsRepository from "../repositories/edazLivingMonthsRepository";

export default class QuarterOptionsService {
  @observable private sourceMonths: Month[];
  @observable private sourceQuarterOptions: string[];

  @computed
  get quarterOptions() {
    return this.sourceQuarterOptions.map(quarterOption => ({ id: quarterOption, label: quarterOption }));
  }

  constructor(private repository: EdazLivingMonthsRepository) {
    this.initialize();
  }

  private initialize() {
    this.sourceMonths = this.repository.createMonths(true);

    const yearGroups = toArray(groupBy(this.sourceMonths, month => month.year));

    this.sourceQuarterOptions = [];

    yearGroups.forEach(group => {
      const groupYear = group[0].year;
      const groupMonths = group.map(x => x.month);

      if (groupMonths.some(x => [1, 2, 3].includes(x))) {
        this.sourceQuarterOptions.push(this.formatQuarterOption(YearQuarter.Q1, groupYear));
      }

      if (groupMonths.some(x => [4, 5, 6].includes(x))) {
        this.sourceQuarterOptions.push(this.formatQuarterOption(YearQuarter.Q2, groupYear));
      }

      if (groupMonths.some(x => [7, 8, 9].includes(x))) {
        this.sourceQuarterOptions.push(this.formatQuarterOption(YearQuarter.Q3, groupYear));
      }

      if (groupMonths.some(x => [10, 11, 12].includes(x))) {
        this.sourceQuarterOptions.push(this.formatQuarterOption(YearQuarter.Q4, groupYear));
      }
    });
  }

  // Example: 3Q-2021
  private formatQuarterOption(quarter: YearQuarter, year: number) {
    return `${quarter.toString()[1]}Q-${year}`;
  }
}
